import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b736f04"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ci-action-edit block text-lg mr-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "app-label-small font-bold" }, "Partages")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Ajouter un partage", -1))
const _hoisted_3 = { class: "flex flex-column w-full gap-3" }
const _hoisted_4 = { class: "flex flex-row justify-content-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputBlock = _resolveComponent("InputBlock")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.dialogVisible,
    "onUpdate:visible": [
      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      _ctx.setVisible
    ],
    modal: true,
    class: "p-fluid",
    closable: false,
    dismissableMask: true,
    breakpoints: { '960px': '75vw', '640px': '90vw' },
    style: { width: '50vw' }
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_InputBlock, {
          label: "NOM",
          modelValue: _ctx.v$.formData.name.$model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.formData.name.$model) = $event)),
          vuelidate: _ctx.v$.formData.name
        }, null, 8, ["modelValue", "vuelidate"]),
        _createVNode(_component_InputBlock, {
          label: "ADRESSE EMAIL",
          modelValue: _ctx.v$.formData.email.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.formData.email.$model) = $event)),
          vuelidate: _ctx.v$.formData.email
        }, null, 8, ["modelValue", "vuelidate"]),
        _createVNode(_component_InputBlock, {
          label: "ROLE",
          vuelidate: _ctx.v$.formData.role
        }, {
          default: _withCtx(({ invalid }) => [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedRole,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedRole) = $event)),
              options: _ctx.roleOptions,
              optionLabel: "label",
              class: _normalizeClass({
                'p-invalid': invalid
              })
            }, null, 8, ["modelValue", "options", "class"])
          ]),
          _: 1
        }, 8, ["vuelidate"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_app_button, {
          buttonType: "secondary",
          buttonSize: "m",
          buttonText: "Annuler",
          isDisabled: false,
          onClick: _ctx.hide
        }, null, 8, ["onClick"]),
        _createVNode(_component_app_button, {
          buttonType: "main",
          buttonSize: "m",
          buttonText: "Ajouter",
          onClick: _ctx.changePassword,
          disabled: _ctx.v$.$invalid
        }, null, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onUpdate:visible"]))
}